<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import PodcastSection from "../components/PodcastSection.svelte";
	import BlogPosts from "../components/BlogPosts.svelte";
	import Conferences from "../components/Conferences.svelte";
	import Contact from "../components/Contact.svelte";
	import type { PodcastProps } from "./PodcastProps.js";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import podcast from "../assets/images/podcast.png";

	type $$Props = PodcastProps;

	const { activeEvent, blogPosts, podcasts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, podcast);
</script>

<Layout>
	<div class="container mt-16 flex flex-col gap-20 px-4 lg:gap-32 lg:px-6 xl:px-8">
		<PodcastSection {podcasts} loading="eager" />
		<BlogPosts {blogPosts} />
	</div>
	<Conferences {activeEvent} />
	<Contact />
</Layout>
